import { render } from "./AppStart.vue?vue&type=template&id=0d1df5f4&scoped=true"
import script from "./AppStart.vue?vue&type=script&lang=js"
export * from "./AppStart.vue?vue&type=script&lang=js"

import "./AppStart.vue?vue&type=style&index=0&id=0d1df5f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1df5f4"]])

export default __exports__